import React from 'react';

import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';
import { Dropdown, Menu, Tooltip } from 'antd';
import { connect } from 'react-redux';
import { debounce, isEmpty } from 'lodash';
import { Link } from 'react-router-dom';

import {
  RootState,
  isExternalUrl,
  isActivitiesSiblingLink,
  getPreferenceFromAccount,
  getLocalURI,
  isStandaloneAnonymousFlowFromPath,
  isBookFromPath,
  isSignInFromPath,
  isSignUpFromPath,
  VACATIONS_PAGE,
  GetHomeParams,
  isCondoEngineFromPath,
  GetDisableNewTabOpen,
  isResultsFromPath,
  isDetailFromPath,
  isChangePasswordFromPath,
  isErrorFromPath,
  isSavedPropertiesFromPath,
  isReservationsFromPath,
  isForgotPasswordFromPath,
  isDisplayCertificates,
  isPublicClubSiteAnonymousVisitor,
  isPublicClubSiteMemberLoggedIn,
} from '@share/utils';
import { IDatesState, IHotelsState, ILocationsState, ILoginState, logout, setLoginRedirect } from '@share/store/slices';
import { getPreferenceFileUrlFromAccount, LoginType } from '@share/utils';
import { HOME_PAGE_URL_FIELD_KEY, IAccount, LOGO_FIELD_KEY, RSI_HOME_NAMES } from '@share/common-types';
import { Routes } from '@share/constants';
import { SkeletonHeader, ModalInternalization } from '@components';
import { PointsLocationsEnum } from '@common-types';

import Logo from '@assets/images/logo_black.png';

import {
  getNavigationMenu,
  IMenuState,
  setVisible,
  setIsUpdateMenu,
  getBenefits,
  IBenefitsState,
  resetHotelsFull,
  endImpersonation,
  walletDrawerActions,
} from '@share/store/slices';
import { ICondoReviewBookState, IHotelDetailsState, IReviewBookState } from '@store/slices';
import { resetCondosFull } from '@share/store/slices';
import { APP_SELECTOR } from '@constants';

import { GiftCardFirstLoginModal } from '../gift-card-first-login-modal';
import { HeaderNavigation } from '../header-navigation';
import { HeaderWelcome } from '../header-welcome';
import { GiftCard } from '../gift-card';
import { WalletDrawer, WalletDrawerTrigger, FailedInstalmentPaymentModal } from '../../certificates/wallet-drawer';

import './style.scss';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DEBOUNCE_TIME = 100;

interface IMapStateToProps {
  menuStore: IMenuState;
  loginStore: ILoginState;
  benefitsStore: IBenefitsState;
  reviewBookStore: IReviewBookState;
  condoReviewBookStore: ICondoReviewBookState;
  locationsStore: ILocationsState;
  datesStore: IDatesState;
  hotelsStore: IHotelsState;
  hotelDetailsStore: IHotelDetailsState;
  walletDrawerStore: { isOpen: boolean };
}

interface IMapDispatchToProps {
  setVisible: (visible: boolean) => void;
  setIsUpdateMenu: (value: boolean) => void;
  setLoginRedirect: (redirect: string) => void;

  getNavigationMenu: () => void;
  resetHotelsFull: () => void;
  resetCondosFull: () => void;
  logout: () => void;
  endImpersonation: () => void;
  getBenefits: (userId: number) => void;
  closeWalletDrawer: () => void;
}

interface IProps
  extends IMapStateToProps,
    IMapDispatchToProps,
    RouteComponentProps,
    WrappedComponentProps {
  matches?: boolean;
  isError?: boolean;
  isVacationRentals?: boolean;
}

const TWO = 2;
const THREE = 3;

interface IState {
  isShowCredits: boolean;
  isShowCreditsDrawer: boolean;
  isScroll: boolean;
  internationalNumbersOpen: boolean;
}

class HeaderComponent extends React.Component<IProps, IState> {
  state: IState = {
    isShowCredits: false,
    isShowCreditsDrawer: false,
    isScroll: false,
    internationalNumbersOpen: false,
  };

  root: HTMLDivElement = document.querySelector(APP_SELECTOR) as HTMLDivElement;

  showDrawer = () => {
    this.props.setVisible(!this.props.menuStore.visible);
  };

  onClose = () => {
    this.props.setVisible(false);
  };

  onCondoOrHotelPage = (): void => {
    if (this.props.menuStore?.items) {
      const { pointsSettings } = this.props.menuStore?.items;
      const isCondoPage =
        this.props.location.pathname.split('/')[TWO] === PointsLocationsEnum.Condo;
      const isCondoBookingPage =
        this.props.location.pathname.split('/')[TWO] === PointsLocationsEnum.CondoBooking;
      const isHotelSearchPage =
        this.props.location.pathname.split('/')[TWO] === PointsLocationsEnum.Search;
      const isHotelPage =
        this.props.location.pathname.split('/')[TWO] === PointsLocationsEnum.Hotel;
      const isHotelBookingPage =
        this.props.location.pathname.split('/')[TWO] === PointsLocationsEnum.HotelBooking;
      const isCarsPages =
        this.props.location.pathname.split('/')[TWO] === PointsLocationsEnum.Cars || this.props.location.pathname.split('/')[THREE] === PointsLocationsEnum.CarsBooking;

      const isCondoDrawer =
        pointsSettings?.condo?.isPointsControlEnabled &&
        !this.props.menuStore?.items?.promo;
      const isCondo = (isCondoPage || isCondoBookingPage) && isCondoDrawer;

      const isHotelDrawer =
        pointsSettings?.hotel?.isPointsControlEnabled &&
        !this.props.menuStore?.items?.promo;
      const isHotel = (isHotelSearchPage || isHotelPage || isHotelBookingPage) && isHotelDrawer;

      const isCarsDrawer = pointsSettings?.car?.isPointsControlEnabled && !this.props.menuStore?.items?.promo;
      const isCars = (isCarsPages) && isCarsDrawer;

      if (isCondoDrawer || isHotelDrawer || isCarsDrawer) {
        this.setState({ isShowCreditsDrawer: true });
      } else {
        this.setState({ isShowCreditsDrawer: false });
      }

      if (isCondo || isHotel || isCars) {
        this.setState({ isShowCredits: true });
      } else {
        this.setState({ isShowCredits: false });
      }
    }
  };

  onScroll = debounce(() => {
    const { pageYOffset } = window;

    this.setState({ isScroll: pageYOffset > 50 });
  }, DEBOUNCE_TIME);

  componentDidMount() {
    const { user, account } = this.props.loginStore;
    const isStandaloneFlowRoute = isStandaloneAnonymousFlowFromPath(this.props.history);
    if (user && !isStandaloneFlowRoute) {
      this.props.getNavigationMenu();
      const isRSITemplate = account?.isRSITemplate;
      if (isRSITemplate) {
        this.props.getBenefits(user.keyid as number);
      }
    }

    window.addEventListener('scroll', this.onScroll);
  }

  componentDidUpdate(prevProps: Readonly<IProps>) {
    const isStandaloneFlowRoute = isStandaloneAnonymousFlowFromPath(this.props.history);
    if (!isStandaloneFlowRoute) {
      if (this.props.menuStore.isUpdateMenu) {
        this.props.getNavigationMenu();
      }

      if (
        prevProps.menuStore.loading !== this.props.menuStore.loading &&
        !this.props.menuStore.loading
      ) {
        this.onCondoOrHotelPage();
      }

      if (prevProps.location !== this.props.location) {
        this.onCondoOrHotelPage();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  renderPhoneInformation = () => {
    const { menuStore } = this.props;
    const { internationalNumbersOpen } = this.state;
    const { items } = menuStore;
    if (items?.phone && items?.showHotline) {

      const hasInternationalPhoneNumbers = !!items?.internationalNumbers?.length;
      
      const menu = (
        <Menu>
          <Menu.Item>
            <div className="condo-weeks-filters__item-content">
              {items?.internationalNumbers?.map((phone, index) => (
                <a href={`tel:${phone?.phone}`} key={`index_${index}`} className="header__phone-numbers-dropdown-item">
                  {phone.iconUrl && 
                    <img src={phone.iconUrl} alt={''} style={{ width: '35px', height: '20px', marginRight: '5px' }} />}
                  {phone.country ? `${phone.country} | ` : ''} {phone.phone}
                </a>
              ))}
            </div>
          </Menu.Item>
        </Menu>
      );
  
      return (
        <div className="header__info-call">
          <p className="header__call-text">
            <FormattedMessage id="call.gent.now" />
          </p>
          <p className="header__call-text mobile">
            <FormattedMessage id="talk.to.our.team" />:
          </p>
          <p className="header__call-text mobile-small">
            <FormattedMessage id="concierge.contact.button" />:
          </p>
          <a href={`tel:${items?.phone}`} className="header__call-number" style={{ borderRight: hasInternationalPhoneNumbers ? 'none' : '1px solid #666666' }}>
            {items?.phone}
          </a>
          {!!hasInternationalPhoneNumbers && (
            <Dropdown 
              overlay={menu}
              trigger={['click']}
              open={internationalNumbersOpen}
              overlayClassName="header__phone-numbers-dropdown"
              onOpenChange={(open) => this.setState({ internationalNumbersOpen: open })}
            >
              <FontAwesomeIcon 
                icon={internationalNumbersOpen ? faChevronUp : faChevronDown}
                style={{ color: '#FFFFFF', borderRight: '1px solid #666666', paddingRight: '10px', cursor: 'pointer' }}
              />
            </Dropdown>
          )}

          {items?.phone2 ? ' ' : ''}
          {items?.phone2 ? (
            <a href={`tel:${items?.phone2}`} className="header__call-number">
              {items?.phone2}
            </a>
          ) : null}
        </div>
      );
    }
    return null;
  };

  renderBoucherLink = () => {
    const { matches, menuStore, loginStore } = this.props;
    const { items } = menuStore;
    const { account } = loginStore;

    if (items?.brochureUrl && items?.showBrochure) {
      const disableNewTabOpen = GetDisableNewTabOpen(account, items);
      return (
        <a
          href={items?.brochureUrl}
          target={(isActivitiesSiblingLink(items?.brochureUrl) || disableNewTabOpen) ? '_self' : '_blank'}
          rel="noreferrer"
          className="header__link-member"
        >
          {matches ? (
            <FormattedMessage id="member.brochure" />
          ) : (
            <FormattedMessage id="member.brochure.short" />
          )}
        </a>
      );
    }
    return null;
  };

  hangleGoToLogin = () => {
    const { loginStore, history } = this.props;
    const { account } = loginStore;

    const { pathname, search } = history.location;
    this.props.setLoginRedirect(`${pathname}${isEmpty(search) ? '' : search}`);

    this.props.history.push(`/${account?.name}${Routes.Login}`);
  };

  hangleGoToSignUp = () => {
    const { loginStore, history } = this.props;
    const { account } = loginStore;

    const { pathname, search } = history.location;
    this.props.setLoginRedirect(`${pathname}${isEmpty(search) ? '' : search}`);

    this.props.history.push(`/${account?.name}${Routes.SignUp}`);
  };

  goHome = () => {
    const { loginStore, menuStore, history, isVacationRentals } = this.props;
    const { account } = loginStore;
    const { items } = menuStore;

    const homeParams = GetHomeParams(account as IAccount);

    const isRSITemplate = account?.isRSITemplate;

    if (!isStandaloneAnonymousFlowFromPath(history)) {
      const homePageDB = getPreferenceFromAccount(account as IAccount, HOME_PAGE_URL_FIELD_KEY);
      const homePageMenu = items?.homeUrl;
      const redirectPage = !isEmpty(homePageMenu) ? homePageMenu : homePageDB;

      if (!isEmpty(redirectPage)) {
        this.props.history.push(`/${account?.name}${getLocalURI(redirectPage as string)}`);
      } else {
        if (isRSITemplate) {
          this.props.resetCondosFull();
          this.props.resetHotelsFull();
          this.props.history.push(`/${account?.name}${Routes.Home}${homeParams}`);
        } else  if (isCondoEngineFromPath(history)) {
          this.props.resetCondosFull();
          this.props.history.push(`/${account?.name}${Routes.CondoSearch}${homeParams}`);
        } else {
          this.props.resetHotelsFull();
          if (isVacationRentals) {
            this.props.history.push(
              `/${account?.name}${Routes.Search}/${VACATIONS_PAGE}${homeParams}`,
            );
          } else {
            this.props.history.push(`/${account?.name}${Routes.Search}${homeParams}`);
          }
        }
      }
    }
  };

  renderInformation = () => {
    const { menuStore, loginStore, history, intl } = this.props;
    const { items } = menuStore;
    const { account, user } = loginStore;

    const isPublicAccountType = account?.type === LoginType.Public;
    const isPrivateTokenAccountType = account?.type === LoginType.PrivateWithToken;
    const isStandaloneFlowRoute = isStandaloneAnonymousFlowFromPath(history);

    const isAshevillePlay = account?.isAshevillePlay;

    const isBookRoute = isBookFromPath(history);
    const homeParams = GetHomeParams(account as IAccount);

    if (!isAshevillePlay && !isStandaloneFlowRoute && !isPublicAccountType && !!user) {
      const isRSITemplate = account?.isRSITemplate;

      const displayMenu = !!items && !!items?.header && !items?.isMLM;
      const displayQuotes = isRSITemplate && !items?.isMLM;
      const displayMyAccount =
        isPrivateTokenAccountType &&
        !account?.isCapitalVacationsCondoRes &&
        (!isRSITemplate ||
          (items?.showMyAccount &&
            !(items.isTravelAgent && account?.levartiOrgIds?.includes(items.organizationId))));

      const hasAnotherOption = displayMenu || displayQuotes || displayMyAccount;

      const displayPhoneInformation = items?.phone && items?.showHotline;
      const displayBoucherLink = items?.brochureUrl && items?.showBrochure;
      const diplayInfo = displayPhoneInformation || displayBoucherLink;

      const styles = account?.subHeaderColor ? { background: account?.subHeaderColor } : {};
      
      const headerHideSubHeader = account?.headerHideSubHeader;
      if (headerHideSubHeader) {
        return null;
      }

      const disableNewTabOpen = GetDisableNewTabOpen(account, items);

      const forceLocalMenu = account?.isAshevillePlay ? false : import.meta.env.VITE_FORCE_MENU === 'true';

      return (
        <div
          className={`header__info ${items?.isMLM ? 'is-mlm' : ''} ${!diplayInfo ? 'no-info' : ''}`}
          style={styles}
        >
          <div className="header__info-item">
            {this.renderPhoneInformation()}
            {this.renderBoucherLink()}
          </div>
          <div className="header__items">
            {!isBookRoute ? (
              <div
                className={`header__user-info information ${!hasAnotherOption ? 'no-padding' : ''}`}
              >
                <ModalInternalization onOpen={this.onClose} forceWhite />
              </div>
            ) : null}

            {displayMenu
              ? items.header.map((item, index) => {
                const localURI = item.url?.replace(/^.*\/\/[^\/]+/, '');
                const external = isExternalUrl(item.url as string);
          
                return (
                  item?.url === 'disabled' ? (
                    <label style={{ cursor: 'not-allowed' }}>
                      <Tooltip
                        title={intl.formatMessage({ id: '"menu.link.disable' })}
                        placement="top"
                      >
                        <FormattedMessage id={item.title} />
                      </Tooltip>
                    </label>
                  ) : (external && !forceLocalMenu) ? (
                    <a
                      key={`${index}${item.title}`}
                      href={item.url}
                      target={(isActivitiesSiblingLink(item.url) || disableNewTabOpen) ? '_self' : '_blank'}
                      rel="noreferrer"
                      className="header__item-navigation"
                    >
                      <FormattedMessage id={item.title} />
                    </a>
                  ) : (
                    <Link
                      key={`${index}${item.title}`}
                      to={`/${account?.name}${forceLocalMenu ? localURI : getLocalURI(item.url as string)}`}
                      className="header__item-navigation"
                    >
                      <FormattedMessage id={item.title} />
                    </Link>
                  ))
                })
              : null}

            {displayQuotes && (!isRSITemplate || items?.showMyAccount) ? (
              <Link
                key={`0myquotes`}
                to={`/${account?.name}${Routes.RsiQuotes}`}
                className="header__item-navigation"
              >
                <FormattedMessage id="my.quotes" />
              </Link>
            ) : null}

            {displayMyAccount ? (
              <Link
                key={`0account`}
                to={`/${account?.name}${getLocalURI('/account')}${homeParams}`}
                className="header__item-navigation"
              >
                <FormattedMessage id="my.account.title" />
              </Link>
            ) : null}
          </div>
        </div>
      );
    }
    return null;
  };

  render(): React.ReactNode {
    const { isShowCreditsDrawer, isShowCredits, isScroll } = this.state;
    const { loginStore, menuStore, locationsStore, datesStore, hotelsStore, hotelDetailsStore, history, isError, isVacationRentals, matches } = this.props;
    const { account, user, userWallet } = loginStore;
    const { loading, items } = menuStore;
    const { isSearch, hotels, loading: hotelsLoading } = hotelsStore;
    const { loading: hotelDetailsLoading } = hotelDetailsStore;

    const logoDB = getPreferenceFileUrlFromAccount(account as IAccount, LOGO_FIELD_KEY);
    const homePageDB = getPreferenceFromAccount(account as IAccount, HOME_PAGE_URL_FIELD_KEY);
    const homePageMenu = items?.homeUrl;
    const headerBackgroundColorDB = account?.headerBackgroundColor;
    const isDisableHomes = account?.isDisableHomes;
    const disableHomesRedirect = account?.disableHomesRedirect;
    const headerTextUpperCase = account?.headerTextUpperCase;
    const isAshevillePlay = account?.isAshevillePlay;
    const ashevillePlayGoogleLogo = account?.ashevillePlayGoogleLogo;
    const ashevillePlayGoogleLogoScroll = account?.ashevillePlayGoogleLogoScroll;

    const isPublicAccountType = account?.type === LoginType.Public;

    const redirectPage = !isEmpty(homePageMenu) ? homePageMenu : homePageDB;
    const isCustomRedirect = !isEmpty(redirectPage) && isExternalUrl(redirectPage as string);
    const isStandaloneFlowRoute = isStandaloneAnonymousFlowFromPath(history);
    const isBookRoute = isBookFromPath(history);
    const isSignInRoute = isSignInFromPath(history);
    const isSignUpRoute = isSignUpFromPath(history);
    const isForgotPasswordRoute = isForgotPasswordFromPath(history);

    const style: any = { backgroundColor: !isEmpty(headerBackgroundColorDB) ? headerBackgroundColorDB : '#FFFFFF' };

    const hasRenderInformation = !isStandaloneFlowRoute && !isPublicAccountType && !!user;

    const hasClientCash = account?.hasClientCash;
    const isRSITemplate = account?.isRSITemplate;
    const headerFloating = account?.headerFloating;
    const logoSkipWidth = account?.logoSkipWidth;

    const isLoggedAshevillePlay = isAshevillePlay && !user?.isAshevillePlayAdmin;
    const isPublicClubSiteMember = isPublicClubSiteMemberLoggedIn(account);
    const isLogged = !!userWallet || isLoggedAshevillePlay || isPublicClubSiteMember;
    const isAnonymousPublicClubSite = isPublicClubSiteAnonymousVisitor(account);
    const showHeaderAuthLinks =
      (hasClientCash || isAshevillePlay || isAnonymousPublicClubSite) &&
      !isLogged &&
      !isSignInRoute &&
      !isSignUpRoute &&
      !isForgotPasswordRoute;
    const showSignUpLink = showHeaderAuthLinks && (hasClientCash || isAshevillePlay);

    if (account?.forceIframe) {
      return null;
    }

    const homeLogoRsi = !isRSITemplate || items?.showHomeUrl;
    
    const disableNewTabOpen = GetDisableNewTabOpen(account, items);

    const displayCertificates = isDisplayCertificates(account as IAccount);

    const isSearchPage = isResultsFromPath(history);
    const isDetailPage = isDetailFromPath(history);
    const isLoginPage = isSignInFromPath(history);
    const isSignUpPage = isSignUpFromPath(history);
    const isForgotPasswordPage = isForgotPasswordFromPath(history);

    const isAfterSearchLoad = (isSearch && !(!!locationsStore.error || !!datesStore.error)) || (hotels && !!hotels.length);

    const isAshevillePlayDisplay = isAshevillePlay && 
                                      ((isSearchPage && !isAfterSearchLoad && !hotelsLoading) || 
                                       (isDetailPage && !hotelDetailsLoading)/* || 
                                        isErrorPage ||
                                        isSavedPropertiesPage ||
                                        isReservationsPage ||
                                        isChangePasswordPage*/);

    const logo = (isAshevillePlayDisplay && !isEmpty(ashevillePlayGoogleLogo)) ? 
                    !isScroll ? 
                        ashevillePlayGoogleLogo : 
                        !isEmpty(ashevillePlayGoogleLogoScroll) ?
                            ashevillePlayGoogleLogoScroll :
                            ashevillePlayGoogleLogo :
                    (isAshevillePlay && !isAshevillePlayDisplay && !isEmpty(ashevillePlayGoogleLogoScroll)) ? 
                        ashevillePlayGoogleLogoScroll :
                        !isEmpty(items?.logoUrl) ? 
                            items?.logoUrl : 
                            !isEmpty(logoDB) ? 
                                logoDB : 
                                Logo;

    if ((isLoginPage || isSignUpPage || isForgotPasswordPage) && isAshevillePlay) {
      return null;
    }

    return (
      <>
        {!loading && !isError ? (
          <div className={`header box-shadow-header${isAshevillePlayDisplay ? ' asheville-play-header' : ''}${(isAshevillePlayDisplay && isScroll)? ' asheville-play-header-scroll' : ''}${headerTextUpperCase ? ' upper-case' : ''}${headerFloating ? ' floating-header' : ''}`} style={style}>
            {this.renderInformation()}

            <div
              className={`header__content ${isRSITemplate && RSI_HOME_NAMES.includes(account?.name || '') ? 'rsi-template' : ''} ${logoSkipWidth ? 'skip-width' : ''}`}
            >
              {!isCustomRedirect && !isDisableHomes && homeLogoRsi && (
                <div
                  className={`header__logo ${isStandaloneFlowRoute ? '' : 'go-home'}`}
                  onClick={this.goHome}
                >
                  <img className="logo-icon" src={logo} alt={'logo'} />
                </div>
              )}

              {isCustomRedirect && !isDisableHomes && homeLogoRsi ? (
                items?.isMLM ? (
                  <Link className="header__logo" to={`/${account?.name}/home`} rel="noreferrer">
                    <img className="logo-icon" src={logo} alt={'logo'} />
                  </Link>
                ) : (
                  <a
                    href={redirectPage}
                    className="header__logo"
                    target={disableNewTabOpen ? '_self' : '_blank'}
                    rel="noreferrer"
                  >
                    <img className="logo-icon" src={logo} alt={'logo'} />
                  </a>
                )
              ) : null}

              {((isDisableHomes && isEmpty(disableHomesRedirect)) || !homeLogoRsi) && (
                <div className="header__logo">
                  <img className="logo-icon" src={logo} alt={'logo'} />
                </div>
              )}

              {isDisableHomes && !isEmpty(disableHomesRedirect) && homeLogoRsi && (
                <a
                  href={disableHomesRedirect}
                  className="header__logo"
                  target={disableNewTabOpen ? '_self' : '_blank'}
                  rel="noreferrer"
                >
                  <img className="logo-icon" src={logo} alt={'logo'} />
                </a>
              )}

              <HeaderNavigation matches={matches} isShowCreditsDrawer={isShowCreditsDrawer} isVacationRentals={isVacationRentals} />
              {displayCertificates && <WalletDrawerTrigger />}

              {!hasRenderInformation && !isBookRoute ? (
                <div className="header__user-info desktop">
                  <ModalInternalization onOpen={this.onClose} />
                </div>) : null}

              <GiftCard />

              {<HeaderWelcome matches={matches} isShowCredits={isShowCredits} />}

              {showHeaderAuthLinks && (
                <div className="header__user-info desktop">
                  <div
                    className="header__link-nav-child-link"
                    style={showSignUpLink ? { marginRight: '6px' } : undefined}
                    onClick={this.hangleGoToLogin}
                  >
                    <FormattedMessage id="sign.in" />
                  </div>
                  {showSignUpLink ? (
                    <>
                      {' '}
                      <FormattedMessage id="or" />{' '}
                      <div
                        className="header__link-nav-child-link"
                        style={{ marginLeft: '6px' }}
                        onClick={this.hangleGoToSignUp}
                      >
                        <FormattedMessage id="sign.up" />
                      </div>
                    </>
                  ) : null}
                </div>
              )}
            </div>

            <GiftCardFirstLoginModal />
          </div>
        ) : null}

        {loading || isError ? <SkeletonHeader active={!isError} /> : null}
        {displayCertificates && (
          <>
            <FailedInstalmentPaymentModal />
            <WalletDrawer
              isOpen={this.props.walletDrawerStore.isOpen}
              onClose={this.props.closeWalletDrawer}
              accountUsername={account?.name ?? ''}
            />
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    condoReviewBookStore: state.condoReviewBookStore,
    reviewBookStore: state.reviewBookStore,
    menuStore: state.navigationMenuStore,
    loginStore: state.loginStore,
    benefitsStore: state.benefitsStore,
    locationsStore: state.locationsStore,
    datesStore: state.datesStore,
    hotelsStore: state.hotelsStore,
    hotelDetailsStore: state.hotelDetailsStore,
    walletDrawerStore: state.walletDrawerStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getNavigationMenu,
  setLoginRedirect,
  setVisible,
  setIsUpdateMenu,
  logout,
  endImpersonation,
  getBenefits,
  resetHotelsFull,
  resetCondosFull,
  closeWalletDrawer: () => walletDrawerActions.setWalletDrawerOpen(false),
};

export const Header = connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(HeaderComponent)));
